import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { localize } from '../../../common/localization';
import { PERIOD } from '../../../constants/enrollment';

const TableHeader = ({ columns, cssClass, hasFourthPeriod, showFourthPeriodLabel }) => (
    <div
        className={classNames('dashboard-table-header', 'dashboard-' + cssClass, {
            'dashboard-has-fourth-period': hasFourthPeriod,
        })}
        data-test-id={`table-header-${columns[0]
            .trim()
            .toLowerCase()
            .split(' ')
            .join('-')}`}
    >
        {columns.map(name =>
            name === PERIOD.SUMMER && !showFourthPeriodLabel ? (
                <div key={name} />
            ) : (
                <div key={name}>{localize(name)}</div>
            ),
        )}
    </div>
);

TableHeader.propTypes = {
    columns: PropTypes.array,
    cssClass: PropTypes.string,
    hasFourthPeriod: PropTypes.bool,
    showFourthPeriodLabel: PropTypes.bool,
};

TableHeader.defaultProps = {
    columns: [],
    cssClass: 'dashboard-',
    hasFourthPeriod: false,
    showFourthPeriodLabel: false,
};

export default TableHeader;
